// 统一请求路径前缀在libs/axios.js中修改
import {getRequest, postRequest, putRequest, deleteRequest, uploadFileRequest} from '@/libs/axios';


// 添加
export const add = (params) => {
    return postRequest('/base/feedback/add', params)
}

// 修改
export const edit= (params) => {
    return postRequest('/base/feedback/edit', params)
}
// 删除
export const delByIds = (ids) => {
    return postRequest("/base/feedback/delByIds",{
        ids: ids
    })
}
//删除用户所有反馈
export const delAll = (id) => {
    return getRequest(`/base/feedback/delAll/${id}`)
}
//删除单条反馈
export const delOne = (id) => {
    return getRequest(`/base/feedback/delOne/${id}`)
}
// 列表
export const list = (params) => {
    return postRequest('/base/feedback/list', params)
}

// 获取单个对象
export const getfeedback = (id) => {
    return getRequest(`/base/feedback/get/${id}`)
}

//留言反馈详情
export const feedbackDetail = (id) => {
    return getRequest(`/base/feedback/feedbackInfo/${id}`)
}